import { useState } from "react";
import { Link, useLocation, matchPath } from "react-router-dom";
import { useSelector } from "react-redux";
import { Menu, X } from "lucide-react";
import logo from "../assets/Logo/logo.png";
import ProfileDropdown from "../components/Auth/ProfileDropdown";

const navItems = [
  { title: "Home", href: "/" },
  { title: "About Us", href: "https://www.thesafetymaster.com/about-us/" },
  { title: "Contact", href: "https://www.thesafetymaster.com/contact-us/" },
];

function Navbar() {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const matchRoute = (route) => matchPath({ path: route }, location.pathname);

  return (
    <header className=" z-50 w-full bg-white/90 shadow-sm backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
        {/* Logo */}
        <Link to="/">
          <img src={logo} alt="Logo" className="h-14 w-auto" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-6 text-sm font-medium text-gray-600">
          {navItems.map((item) => (
            <a
              key={item.title}
              href={item.href}
              className={`hover:text-blue-600 transition-colors ${
                matchRoute(item.href) ? "text-blue-600" : ""
              }`}
            >
              {item.title}
            </a>
          ))}
        </nav>

        {/* Auth Buttons */}
        <div className="hidden md:flex items-center space-x-4">
          {token ? (
            <ProfileDropdown />
          ) : (
            <>
              <Link to="/login">
                <button className="text-sm bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-500">
                  Log in
                </button>
              </Link>
              <Link to="/signup">
                <button className="text-sm bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-500">
                  Sign up
                </button>
              </Link>
            </>
          )}
        </div>

     <div className="md:hidden lg:hidden flex flex-row items-center gap-2">
     <div className="md:hidden lg:hidden flex items-center">
     {token ? (
            <div className="pt-2">
              <ProfileDropdown />
            </div>
          ) : (
            <div className="pt-2 space-y-2 space-x-2">
              <Link to="/login" className="text-sm bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-500">
                Log in
              </Link>
              <Link to="/signup" className="text-sm bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-500">
                Sign up
              </Link>
            </div>
          )}
     </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
     </div>
      </div>
          
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden px-4 py-3 border-t bg-white space-y-2">
          {navItems.map((item) => (
            <a
              key={item.title}
              href={item.href}
              className="block text-sm text-gray-700 hover:text-blue-600"
            >
              {item.title}
            </a>
          ))}

          
        </div>
      )}
    </header>
  );
}

export default Navbar;
